export const BACK_TO_SCHOOL_CAMPAIGN_DURATION = 7
